module.exports = __webpack_public_path__ + "media/images/advertising-log-478196cd0c72aeafdeca929a7950ffa2.svg";